import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';

/**
 * Composable for internal chat Pro feature gating.
 *
 * Pro features (polls, unlimited private channels, unlimited search history)
 * are tied to the `kanban` feature flag, which represents an active escaleshop
 * subscription. When kanban is disabled, Pro features stay locked and the UI
 * surfaces upgrade CTAs.
 */
export function useInternalChatPro() {
  const currentUser = useMapGetter('getCurrentUser');
  const currentRole = useMapGetter('getCurrentRole');
  const { isCloudFeatureEnabled } = useAccount();

  const proEnabled = computed(() => isCloudFeatureEnabled('kanban'));

  return {
    pollsEnabled: proEnabled,
    maxPrivateChannels: computed(() => (proEnabled.value ? null : 2)),
    searchHistoryDays: computed(() => (proEnabled.value ? null : 90)),
    isSuperAdmin: computed(() => currentUser.value?.type === 'SuperAdmin'),
    isAdmin: computed(() => currentRole.value === 'administrator'),
  };
}
